import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [f, setF] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(f.email, f.password);
            nav("/admin/dashboard");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-brand-beige flex items-center justify-center p-6">
            <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-sm" data-testid="admin-login-page">
                <h1 className="font-heading text-3xl text-brand-ink font-semibold mb-2">Espace conseiller</h1>
                <p className="text-sm text-brand-ink/60 mb-6">Connectez-vous pour accéder au tableau de bord.</p>
                <form onSubmit={submit} className="space-y-3">
                    <label className="block">
                        <span className="block text-sm text-brand-ink/70 mb-1">Email</span>
                        <input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}
                            className="w-full min-h-[48px] rounded-xl border border-brand-ink/15 px-4 focus:outline-none focus:ring-2 focus:ring-[#2A84C8]/30 focus:border-[#2A84C8]"
                            data-testid="input-email" />
                    </label>
                    <label className="block">
                        <span className="block text-sm text-brand-ink/70 mb-1">Mot de passe</span>
                        <input type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
                            className="w-full min-h-[48px] rounded-xl border border-brand-ink/15 px-4 focus:outline-none focus:ring-2 focus:ring-[#2A84C8]/30 focus:border-[#2A84C8]"
                            data-testid="input-password" />
                    </label>
                    <button disabled={loading} className="primary-btn w-full mt-2" data-testid="login-submit-btn">
                        {loading ? "Connexion..." : "Se connecter"}
                    </button>
                </form>
                <button
                    onClick={async () => {
                        if (!f.email) { toast.info("Renseignez l'email d'abord."); return; }
                        try {
                            const r = await api.post("/auth/forgot_password", { email: f.email });
                            toast.success(r.data?.message || "Demande enregistrée.");
                        } catch (e) { toast.error(formatApiError(e)); }
                    }}
                    className="block mx-auto text-sm text-[#2A84C8] hover:underline mt-4"
                    data-testid="forgot-password-btn"
                    type="button"
                >
                    Mot de passe oublié ?
                </button>
                <Link to="/" className="block text-center text-sm text-brand-ink/50 hover:text-[#2A84C8] mt-4">
                    Retour à l'accueil
                </Link>
            </div>
        </div>
    );
}
